export enum ERoomColoringCategoryId {
  IfcEgenskaper = "ifc_egenskaper",
  RfpEgenskaper = "rfp_egenskaper",
  RfpStandardromValidering = "rfp_standardromvalidering",
  RfpArtikkelvalidering = "rfp_artikkelvalidering",
  System = "system",
  MepLaster = "mep_laster",
  Annet = "annet",
}

/**
 * Valgfritt: underkategorier for å holde menyen ryddig når dere får mange filtre
 */
export enum ERoomColoringSubcategoryId {
  // IFC
  IfcTypeOgPredefinedType = "ifc_type_og_predefined_type",
  IfcPsets = "ifc_psets",
  IfcMaterialer = "ifc_materialer",
  IfcEtasjeOgBygning = "ifc_etasje_og_bygning",

  // RFP
  RfpRomData = "rfp_romdata",
  RfpKrav = "rfp_krav",
  RfpKlassifisering = "rfp_klassifisering",

  // Validering
  ValideringStatus = "validering_status",
  ValideringAvvik = "validering_avvik",

  // System
  SystemTilhorighet = "system_tilhorighet",

  // Laster
  Luftmengder = "luftmengder",
  EffektVarme = "effekt_varme",
  EffektKjoling = "effekt_kjoling",
  AntallPersoner = "antall_personer",

  Annet = "annet",
}

export interface IRoomColoringExplanation {
  /**
   * Kort tekst (tooltip / undertekst i meny)
   */
  shortNo: string;

  /**
   * Litt lengre forklaring (drawer/modal/hjelpetekst)
   */
  longNo?: string;

  /**
   * Valgfritt: lenke til intern doc, eller nøkkel dere mapper til docs.
   */
  docKey?: string;
}

export interface IRoomColoringCategoryMeta {
  id: ERoomColoringCategoryId;
  titleNo: string; // "IFC-egenskaper", osv.
  descriptionNo?: string;
  order: number;
  icon?: string; // f.eks. "Ifc", "Checklist", "System", "Bolt" (dere bestemmer mapping)
}

export const ROOM_COLORING_CATEGORIES: IRoomColoringCategoryMeta[] = [
  {
    id: ERoomColoringCategoryId.IfcEgenskaper,
    titleNo: "IFC-egenskaper",
    descriptionNo: "Fargelegging basert på data i IFC (type, property sets, etasje, materialer).",
    order: 10,
    icon: "Ifc",
  },
  {
    id: ERoomColoringCategoryId.RfpEgenskaper,
    titleNo: "RFP-egenskaper",
    descriptionNo: "Fargelegging basert på rom- og kravdata fra RFP (dRofus el.l.).",
    order: 20,
    icon: "FileText",
  },
  {
    id: ERoomColoringCategoryId.RfpStandardromValidering,
    titleNo: "RFP Standardromvalidering",
    descriptionNo: "Status/avvik for standardrom-regler.",
    order: 30,
    icon: "CheckSquare",
  },
  {
    id: ERoomColoringCategoryId.RfpArtikkelvalidering,
    titleNo: "RFP Artikkelvalidering",
    descriptionNo: "Status/avvik for artikler i rom.",
    order: 40,
    icon: "ClipboardCheck",
  },
  {
    id: ERoomColoringCategoryId.System,
    titleNo: "System",
    descriptionNo: "Tilhørighet til tekniske systemer (ventilasjon, varme, kjøling, sprinkler...).",
    order: 50,
    icon: "Network",
  },
  {
    id: ERoomColoringCategoryId.MepLaster,
    titleNo: "MEP-laster",
    descriptionNo: "Romlaster som luftmengder, varme-/kjøleeffekt, personbelastning osv.",
    order: 60,
    icon: "Gauge",
  },
  {
    id: ERoomColoringCategoryId.Annet,
    titleNo: "Annet",
    descriptionNo: "Diverse filtre som ikke passer i de andre kategoriene.",
    order: 99,
    icon: "DotsHorizontal",
  },
];
